


















import { Component, Vue } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import InviteCustomerInStoreEmptyState from './InviteCustomerInStoreEmptyState.vue';
import InviteCustomerInStoreCreate from './InviteCustomerInStoreCreate.vue';

@Component({
  components: {
    Page,
    Typography,
    InviteCustomerInStoreEmptyState,
    InviteCustomerInStoreCreate
  }
})
export default class InviteCustomerInStore extends Vue {
  openedForm = false;

  get tPrefix() {
    return 'inviteCustomerInStore';
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }
}
